module.exports = __webpack_public_path__ + "img/signing.7059f939.png";